import { ServiceLocator } from '../../app/ServiceLocator';
import { Messages } from '../../codegen/Localize';
import { GetLocalesRequest } from '../ServerApi/requests/GetLocalesRequest';
import { ILocale } from '../ServerApi/types/ILocale';
import WebHttpClient from '../../httpClient/WebHttpClient';

export class Locales {

  public getAll(): ng.IPromise<ILocale[]> {
    return WebHttpClient.sendRequest(new GetLocalesRequest()).then(result => result.locales);
  }

  // a special value for the user locale that indicates that we should use the server locale
  public unspecifiedLocale(): ILocale {
    return {
      displayName: Messages.unspecified(),
      locale: null
    };
  }

}

export const LocalesInstance = new Locales();
